import { BaseInput } from "./model";

export interface ContainerArgs {
    children: (BaseInput | Container)[]
    builder?: (children: (BaseInput | { $el: string })[]) => { $el: string }
}

export class Container {
    constructor(protected args: ContainerArgs) {}

    filters(attrs?: any) {
        return this.args.children.map(c => Object.assign(c, { ...attrs }))
    }

    inputs(): BaseInput[] {
        return this.args.children.map(child => {
            if (child instanceof Container) {
                return child.inputs()
            }
            return child && child.filter && typeof child.filter === 'function' ? child.filter() : child
        }).flat(Infinity)
    }

    protected get children() {
        return this.args.children.map(child => {
            if (child instanceof Container) {
                return child.getFormkit()
            }
            return child as (BaseInput | {
                $el: string;
            })
        })
    }

    getFormkit(): (FilterSchema | { $el: string }) {
        if (this.args.builder) {
            return this.args.builder(this.children)
        } else {
            return this.defaultBuilder(this.children)
        }
    }

    protected defaultBuilder(children) {
        return {
            $el: 'div',
            attrs: {
                class: 'w-full flex flex-col xl:flex-row gap-3 my-2'
            },
            children
        }
    }
}